export default {"src":"/_next/static/media/wb.22992809.svg","height":15,"width":95,"blurWidth":0,"blurHeight":0};